export default "__VITE_ASSET__ysf4oJtT__"